import {Observable} from "rxjs/Rx";
import {IDossierWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class ExamensResolver implements Resolve<any> {

  constructor(private dossierClient: IDossierWebServiceClient) {
  }

  resolve() {
    return this.dossierClient.autoCompleteExamen().catch(response => {
      return Observable.empty();
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/examens.resolver.ts